export const NAV_TOOLTIP_DISMISSED = 'NAV_TOOLTIP_DISMISSED';
